import {ActionButton, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {FieldViewerComponent} from "../../../app/shared/field-viewer/field-viewer.component"
import {ApiPathsService} from "../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {DynamicListComponent} from "../../../app/shared/dynamic-list/dynamic-list.component";
import {AddButtonCard, GetMyPrice, idsToBase64, productCrudUtility, RichiediProdotto} from "./ProductUtility";
import {DynamicEditComponent} from "../../../app/shared/dynamic-edit/dynamic-edit.component";
import {GetFromLocalStorage, SaveToLocalStorage} from "../../Utility/Utility";
import {IsMarcaPref} from "./Segui";

function IsProdottoPreferito(prodotto: any): boolean {
  const userId = GetFromLocalStorage('currentUser')?.id;
  return prodotto.preferito?.includes(userId);
}

function ToggleProdottoPreferito(prodotto: any, component: FieldViewerComponent) {
  const userId = GetFromLocalStorage('currentUser')?.id;

  if (!userId) {
    return;
  }

  const isPreferito = IsProdottoPreferito(prodotto);

  if (isPreferito) {
    prodotto.preferito = prodotto.preferito?.filter(id => id !== userId) ?? [];

    component.apiPaths.ClassicPost('/prodotti/preferiti/delete', { id: prodotto.id })
      .subscribe(() => {
        component.toastService.success("Prodotto rimosso dai preferiti", "", {
          toastClass: 'marketplace-success-toast'
        });
      });

  } else {
    prodotto.preferito = [...(prodotto.preferito ?? []), userId];

    component.apiPaths.ClassicPost('/prodotti/preferiti/add', { id: prodotto.id })
      .subscribe(() => {
        component.toastService.success("Prodotto aggiunto ai preferiti", "", {
          toastClass: 'marketplace-success-toast'
        });
      });
  }
}


export function Catalogo() {
  var OBJ: OggettoConfig = {
    Id: "catalogo",
    RestRoute: '/prodotti',
    listView: 'card',
    EditView: 'Page',
    NoSaveEdit: true,
    ListResponseHasData: true,
    noCardBody: true,
    //ListDefaultFilter: {page:1, all:false, figli:true},
    ListDefaultFilterFunc: (component: DynamicListComponent) => {
      const currentUser = GetFromLocalStorage('currentUser');

      const isMarketplace = currentUser?.ruoliObject?.some(
        r => r.id === 'AZ'
      );

      return {
        page: 1,
        all:false,
        figli: true
      };
    },
    FullResponseMap: (response, component: DynamicListComponent) => {
      return {
        ...response,
        data: response.data.map((prodotto, i) => {
          return {...prodotto}
        }),
        suggerimenti: [
          //{nominativo: 'Antonio Marras', subtitle: '52 capi in saldo fino al 40%', id_immagine: 1289}
        ],

      }
    },
    cardButtons: productCrudUtility(false).cardButtons,
    PrintHeaders: [],
    Filters: [
      {
        type: 'text',
        nome: 'Cerca brand, categoria, prodotto…',
        class: 'shopSearchBar',
        inputClass: 'shop-search-pill',
        hidelabel: true,

        modificabile: true,
        oggetti: ['pdv']
      },
      {
        type: 'CategorieMarketplaceHeader',
        nome: '',
        class: 'col-lg-12',
        source: '/prodotti/categorie/list',
        OnChangeFunc:(x, selected)=>{
          console.log(x, selected);

        },
        parameter: [],
        modificabile: true,
        oggetti: ['cat_id'],
        settings:{
          textField: 'categoria'
        }
      },
      CampoAggiuntivo.SingleDropdown("Brand", "marche", '', "label", {
        source: '/settings/get',
        parameter: [{nome: 'id', value: 'marca_prodotto'}, {nome: 'type', value: 'marca_prodotto'}],
        hideLabel: true,
        placeholder: 'Brand',

      }, 'col-lg-2 mt-3 ml-3 dfilter catalog-filter-dropdown', () => true, {
        dataLabel: "Brand",
        allowSearchFilter: true,
        singleSelection: false,
        singleOutput: false,
        closeDropDownOnSelection: true,
        enableCheckAll: false,
        nullifEmpty: true
      }),
      CampoAggiuntivo.SingleDropdown("Colori", "colori", '/prodotti/colori/list', "check", {
        parameter: [],
        responseHasData: true,
        hideLabel: true,
        placeholder: 'Colore'
      }, 'col-lg-2 mt-3 dfilter catalog-filter-dropdown', () => true, {
        dataLabel: "Colore",
        singleSelection: false,
        singleOutput: false,
        closeDropDownOnSelection: true,
        enableCheckAll: false
      }),
      CampoAggiuntivo.SingleDropdown("Taglia", "taglie", '/prodotti/taglia/filtri', "taglia", {
        parameter: [{nome: 'cat_id', parameter: 'cat_id'}],
        responseHasData: true,
        hideLabel: true,
        url:'/prodotti/taglia/filtri',
        placeholder: 'Taglia'

      }, "col-lg-2 mt-3 dfilter catalog-filter-dropdown", (x) => !!x.cat_id, {
        allowSearchFilter: true,
        singleSelection: false,
        singleOutput: false,
        closeDropDownOnSelection: true,
        enableCheckAll: false
      }),
      CampoAggiuntivo.InputField("Prezzo", "prezzo",'FiltroPrezzo', 'col-lg-1 mt-3 dfilter', {
       type:  'FiltroPrezzo'
      }),
      CampoAggiuntivo.Html("", (x) => `
<div>
      <a class="vfb-pill vfb-pill-promo ${x.promo ? 'active' : ''}" id="vfbPromo" >🏷 Promo</a>
     </div> `, () => true, {
        class: 'col-lg-2 mt-3 dfilter',
        oggetti: ['promo'],
        onClick: (x, component) => {
          x.promo = !x.promo;
          component.ChangeHandler('', x, {});
        }
      }),
      CampoAggiuntivo.InputField("", "fromRicerche", "text", "d-none", {
        modificabile: false
      }),
      /*CampoAggiuntivo.SingleDropdown(
        "",
        "ordinamento",
        [

          { id: "ultimi_arrivi", label:"Ultimi arrivi"},
          { id: "evidenza", label: "In evidenza"},
          { id: "prezzo_asc", label: "Prezzo ↓" },
          { id: "prezzo_desc", label: "Prezzo ↑" },
          { id: "nome_asc", label: "Nome A-Z" },
          { id: "nome_desc", label: "Nome Z-A" },
        ],
        "label",
        {
          hideLabel: true,
          placeholder: "In evidenza",


          OnChangeFunc: (x, selected) => {

            x.page = 1;

            x.orderByNome = null;
            x.orderByPrezzo = null;

            switch (selected?.id ?? selected) {

              case 'prezzo_asc':x.orderByPrezzo = 'asc';
                break;
              case 'prezzo_desc':x.orderByPrezzo = 'desc';
                break;
              case 'nome_asc':x.orderByNome = 'asc';
                break;
              case 'nome_desc':x.orderByNome = 'desc';
              break;
              case 'evidenza':
              default:
                break;
            }

            console.log("ORDINAMENTO PAYLOAD", {
              orderByNome: x.orderByNome,
              orderByPrezzo: x.orderByPrezzo
            });
          }
        },
        "col-lg-2 mt-3 dfilter order-filter-right",
        () => true,
        {
          singleSelection: true,
          singleOutput: true,
          enableCheckAll: false,
          excludeSelectedFilter: true as any
        } as any
      ),*/
      CampoAggiuntivo.InputField("SelectedFilter",'','SelectedFilter','col-12', {
        type: 'SelectedFilter',

      })


    ],
    badges: [
      {nome: 'Prodotti', field: 'total', color: ''},
    ],
    sidebarListSections: [
      {
        nome: "Suggerimenti",
        campo: 'suggerimenti',
        type: 'card',
        ImageUrl: (item, component) => `${component.api.getBaseAPI()}/file/image/${item.id_immagine}`,
        headers: [
          CampoAggiuntivo.TextField("Nome", 'nominativo', '', {class: 'ss-sug-name', modificabile: false}),
          CampoAggiuntivo.TextField("Subtitle", 'subtitle', '', {class: 'ss-sug-sub', modificabile: false}),

        ],
        Azioni: [
          {
            nome: 'Scopri il negozio',
            icon: null,
            class: ' btn ',
            noGet: true,
            labelClass: 'text-success ',
            type: 'func',
            tooltip: "Scopri di più",
            func: (field: any, api: ApiPathsService, onEnd: () => void, Toastr: ToastrService) => {
              console.log("Scopri di più...")
            },
          }
        ]
      },
      // {
      //   nome: "Altri negozi",
      //   campo: 'altri',
      //   type:'list',
      //   ImageUrl: (item, component)=>`${component.api.getBaseAPI()}/file/image/${item.id_immagine}`,
      //   headers: [
      //     CampoAggiuntivo.TextField("Nome", 'nominativo', '',{class: 'ss-shop-name', modificabile:false}),
      //     CampoAggiuntivo.TextField("Subtitle", 'subtitle', '',{class: 'ss-shop-meta', modificabile:false}),
      //
      //   ],
      //   Azioni:[
      //     {
      //       nome: '+',
      //       icon: null,
      //       class: '  ',
      //       noGet:true,
      //       labelClass: 'text-success ',
      //       type: 'func',
      //       tooltip: "Aggiungi ai preferiti",
      //       func:(field:any, api:ApiPathsService, onEnd: ()=>void, Toastr:ToastrService)=>{
      //         console.log("Aggiungi ai preferiti")
      //       },
      //     }
      //   ]
      // }
    ],
    ImageUrl: (item, component) => `${component.api.getBaseAPI()}/file/image/${item.id_immagine}`,
    Headers: [
      {
        nome: "Marca",
        oggetti: ["marcaObject"],
        type: 'object',
        field: ['label'],
        style: {

          'font-size': ' 10.5px',
          'font-weight': '800',
          'color': 'var(--main-color)',
          'text-transform': 'uppercase',
          'letter-spacing': '.4px',
          'margin-bottom': '2px',
        }
      },
      CampoAggiuntivo.TextField("Prodotto", 'prodotto', "", {
        modificabile: false,
        style: {

          ' font-size': '13px',
          'font-weight': '700',
          'color': '#0F172A',
          'white-space': 'nowrap',
          'overflow': 'hidden',
          'text-overflow': 'ellipsis',
          'margin-bottom': '2px',
        }
      }),
      CampoAggiuntivo.TextField("Descrizione", 'descrizione', "", {
        modificabile: false,
        style: {

          ' font-size': '11.5',

          'color': '#64748b',
          'white-space': 'nowrap',
          'overflow': 'hidden',
          'text-overflow': 'ellipsis',
          'margin-bottom': '5px',
        }
      }),

      CampoAggiuntivo.Html("", (prodotto, component: FieldViewerComponent) => {
        var myPrice = GetMyPrice(prodotto, GetFromLocalStorage('currentUser'))
        if (myPrice.isPromo)
          return `
              <div class="ml-2">
                  <span class="pc-price pc-price-wrap">€${myPrice.prezzoSconto?.toDecimals(2)}</span>
                  <span class="pc-old">€${myPrice.prezzoIvato?.toDecimals(2)}</span>
              </div>
          `
        return `
            <div class="ml-2">
                <span class="pc-price pc-price-wrap">€${myPrice.prezzoIvato?.toDecimals(2)}</span>
            </div>
        `
      },()=>true,{
        class:'mb-style',

      }),
    ],
    AzioniLista: [
      AddButtonCard()
    ],
    asyncMap: async (x, component: DynamicEditComponent, callback) => {
      x.qta = 1;
      idsToBase64([x.id_immagine, ...(x.files.map(x => x.id) ?? [])].filter(id => id), component.api.getBaseAPI()).then(immagini=> {
        x.Immagini = immagini;
        x.ImmagineSelezionata = x.Immagini[0];
        x.ImmaginiThumbField = x.Immagini.map((immagine, index) =>
          CampoAggiuntivo.Html("", (prodotto, parent) => `
                 <div class="d-gal-th ${immagine == prodotto.ImmagineSelezionata ? 'active' : ''}">
                    <img src="${immagine}"
                         class="d-gal-img d-gal-img-th"
                         onerror="this.style.display='none';this.parentNode.innerHTML='👗'">
                 </div>
                 `, () => true, {
            onClick: (prodotto, component: FieldViewerComponent) => {
              prodotto.ImmagineSelezionata = immagine;
              console.log("Immagine cliccata", prodotto);
            }
          }));
      });
     // x.Immagini = await idsToBase64([x.id_immagine, ...(x.files.map(x => x.id) ?? [])].filter(id => id), component.api.getBaseAPI())
     // x.ImmagineSelezionata = x.Immagini[0];
      x.DropdownSources = {
        Taglie: [...(x.taglie || [])]
          .filter(taglia => Number(taglia.magazzino ?? 0) > 0)
          .sort(
            (a, b) =>
              Number(a.ordine ?? 0) - Number(b.ordine ?? 0)
          )
      };
      // x.ImmaginiThumbField = x.Immagini.map((immagine, index) =>
      //   CampoAggiuntivo.Html("", (prodotto, parent) => `
      //            <div class="d-gal-th ${immagine == prodotto.ImmagineSelezionata ? 'active' : ''}">
      //               <img src="${immagine}"
      //                    class="d-gal-img d-gal-img-th"
      //                    onerror="this.style.display='none';this.parentNode.innerHTML='👗'">
      //            </div>
      //            `, () => true, {
      //     onClick: (prodotto, component: FieldViewerComponent) => {
      //       prodotto.ImmagineSelezionata = immagine;
      //       console.log("Immagine cliccata", prodotto);
      //     }
      //   }));
      component.api.ClassicPost("/prodotti/list", {
        page: 1,
        size: 6,
        negozio: x.esclusiva
      }).subscribe(async prodottiNegozio => {
        x.AltriNegozio = [];
        prodottiNegozio.data.filter((prodotto) => prodotto.id != x.id).forEach(async (prodotto) => {

          prodotto.Immagine = (await idsToBase64([prodotto.id_immagine], component.api.getBaseAPI()))[0]
          x.AltriNegozio.push(
            CampoAggiuntivo.Html("", `<div class="pc" onclick="openDetail(1)" >
        <div class="pc-img">

          <button class="pc-fav" onclick="event.stopPropagation();toggleLike(this)">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"></path></svg>
            <span>10</span>
          </button>
          <img src="${prodotto.Immagine}" alt="${prodotto.prodotto}" style="width:100%;height:100%;object-fit:cover;" onerror="this.style.display='none';this.parentNode.style.fontSize='40px';this.parentNode.insertAdjacentHTML('beforeend','👗')">
        </div>
        <div class="pc-body">
          <div class="pc-brand">${prodotto.marcaObject?.label}</div>
          <div class="pc-name">${prodotto.prodotto}</div>
          <div><span class="pc-price">€${GetMyPrice(prodotto, component.authSvc.currentUserValue).prezzoIvato.toDecimals(2)}</span></div>
        </div>
      </div>`, () => true, {
              onClick: (tt, component: FieldViewerComponent) => {
                // console.log(prodotto);
                component.router.navigate(["marketplace/shared/dynamicedit/catalogo", prodotto.id])
              }
            })
          )
        })


      })

      //console.log("Prodotto: ", x);
      callback(x);

    },
    campi: [
      CampoAggiuntivo.InputField("", "", "", "dl", {
        type: 'ArrayCampiAggiuntivi',
        campiAggiuntivi: [
          CampoAggiuntivo.InputField("", "", "", "d-gal-col", {
            type: 'ArrayCampiAggiuntivi',
            campiAggiuntivi: [
              CampoAggiuntivo.Html("", (prodotto, parent: FieldViewerComponent) =>
                `
<div class="d-gal-main">
  <div class="detail-product-heart">
      <span>${IsProdottoPreferito(prodotto) ? '❤️' : '🖤'}</span>
    </div>
    ${prodotto.promo ? '<div class="d-gal-bdg">PROMO</div>' : ''}
    ${prodotto.ImmagineSelezionata ? `
      <img
    src="${prodotto.ImmagineSelezionata}"
    alt="${prodotto.prodotto}"
    class="d-gal-img d-gal-img-main"
    onerror="this.style.display='none';this.parentNode.style.fontSize='100px';this.parentNode.insertAdjacentHTML('beforeend','👗')"
  >
    `:`
    <div class="d-gal-img d-gal-img-main image-spinner">
    <div>
    <i class="fas fa-spinner fa-spin"></i>
</div>
</div>
    `}


</div>`, () => true, {
                onClick: (prodotto: any, component: FieldViewerComponent) => {
                  ToggleProdottoPreferito(prodotto, component);
                }
              }),
              CampoAggiuntivo.InputField("", "ImmaginiThumbField", "", "d-gal-thumbs", {
                type: 'ArrayCampiAggiuntivi',

              }),
            ]
          }),
          CampoAggiuntivo.InputField("", "", "", "d-info", {
            type: 'ArrayCampiAggiuntivi',
            campiAggiuntivi: [
              CampoAggiuntivo.Html("", (prodotto, parent: FieldViewerComponent) => {


                return `

      <div class="d-brand-row">
        <span class="d-brand">${prodotto.marcaObject?.label}</span>
<span class="btn-follow-brand" > Segui il brand</span>
      </div> `}, (tt)=>!IsMarcaPref(tt.marcaObject), {
        onClick: (tt, component: FieldViewerComponent) => {
          component.apiPaths.ClassicPost('/anagrafica/clienti/marca/add', {id: tt.marcaObject?.id}).subscribe(
            (res)=>{
              var User = GetFromLocalStorage('currentUser');
              User.marche = [...(User.marche ?? []), tt.marcaObject?.id];
              SaveToLocalStorage('currentUser', User);
              component.toastService.success("Marca seguita","", {toastClass:'marketplace-success-toast'});
            }
          )
        }
      }),
              CampoAggiuntivo.Html("", (prodotto, parent: FieldViewerComponent) => {


                return `
<div class="d-brand-row">
        <span class="d-brand">${prodotto.marcaObject?.label}</span>
<span class="btn-follow-brand" > Segui già</span>
      </div>
`}, (tt)=>IsMarcaPref(tt.marcaObject), {
                nextDivClass:'col-lg-12',
                onClick: (tt, component: FieldViewerComponent) => {
                  component.apiPaths.ClassicPost('/anagrafica/clienti/marca/delete', {id: tt.marcaObject?.id}).subscribe(
                    (res)=>{
                      var User = GetFromLocalStorage('currentUser');
                      User.marche = User.marche?.filter(x=>x!=tt.marcaObject?.id) ?? [];
                      SaveToLocalStorage('currentUser', User);
                      component.toastService.success("Marca rimossa dai seguiti","", {toastClass:'marketplace-success-toast'});
                    }
                  )
                }
              }),
              CampoAggiuntivo.Html("", (prodotto, parent: FieldViewerComponent) => {
                var myPrice = GetMyPrice(prodotto, GetFromLocalStorage('currentUser'));


                return `


      <div class="d-title">${prodotto.prodotto}</div>
<!--      <div class="d-rating-bar"  style="cursor:pointer;" title="Vedi tutte le recensioni">-->
<!--        <span class="d-stars">★★★★★</span>-->
<!--        <span class="d-rating-num">4.4</span>-->
<!--        <span class="d-rating-sep">·</span>-->
<!--        <span class="d-rating-cnt" style="text-decoration:underline;color:var(&#45;&#45;teal);">37 recensioni</span>-->
<!--        <span class="d-rating-sep">·</span>-->
<!--        <span class="d-sales-cnt">54 venduti</span>-->
<!--      </div>-->
      <div class="d-prow">
        <span class="d-pr">€${myPrice?.isPromo ? myPrice.prezzoSconto?.toDecimals(2) : GetMyPrice(prodotto, GetFromLocalStorage('currentUser')).prezzoIvato?.toDecimals(2)}</span>
        <span class="d-iva">(IVA inclusa)</span>
        ${myPrice?.isPromo ? `<span class="d-old">€${myPrice.prezzoIvato?.toDecimals(2)}</span><span class="d-promo-badge">-${myPrice.sconto}%</span>` : ''}
      </div>
      <div class="d-ship-row">
        <span class="icon-truck"></span>
        <strong>Spedizione standard</strong>&nbsp;· Tempi: 3–5 giorni lavorativi
      </div>
      <div class="d-specs">
         <div class="d-spec-row"><span class="d-spec-key">Colore</span><span class="d-spec-val">${prodotto.coloreObject?.map(x => x.check).join(" / ")}</span></div>
        <div class="d-spec-row"><span class="d-spec-key">Categoria</span><span class="d-spec-val">${prodotto.categorie?.map(x => x.categoria).join(" / ")}</span></div>
        <div class="d-spec-row"><span class="d-spec-key">Brand</span><span class="d-spec-val">${prodotto.marcaObject?.label}</span></div>
        <div class="d-spec-row"><span class="d-spec-key">Codice prodotto</span><span class="d-spec-val">${prodotto.codice}</span></div>
        ${prodotto?.stagioneObject?.check ? `<div class="d-spec-row"><span class="d-spec-key">Stagione</span><span class="d-spec-val">${prodotto?.stagioneObject?.check ?? ''}</span></div>`: ''}
        <div class="d-spec-row"><span class="d-spec-key">Stato</span><span class="d-spec-val">Disponibile</span></div>
      </div>
      <div class="d-specs">

      <div class="d-spec-row">
         <span class="d-spec-key">Descrizione</span>

         <span class="d-spec-val d-desc-val">
            ${prodotto?.descrizione ?? ''}
         </span>
      </div>

    </div>

      `
              }),
              CampoAggiuntivo.SingleDropdown("Taglia", "taglia", 'Taglie', "taglia", {}, 'prodotto-brand', () => true, {
                dataLabel: "Taglia",
              }),
              CampoAggiuntivo.InputField("Quantità", "qta", "number", "prodotto-field mt-20", {}),


              CampoAggiuntivo.InputField("", "pippo", "text", "col-lg-12", {
                modificabile: false,
                azioni: [
                  {
                    label: "Richiedi prodotto",
                    type: 'func',
                    func: (field, bottone, campo, Oggetto, api: ApiPathsService, component: FieldViewerComponent) => {
                      RichiediProdotto(Oggetto, api, component.store);
                    },
                    class: 'btn-p'
                  }


                ]
              }),
              CampoAggiuntivo.Html("", (prodotto, component: FieldViewerComponent)=>{
                return `
                <div class="seller-box">
                  <div class="s-av">🏪</div>
                  <div>
                    <div class="s-name">${prodotto.esclusivaObject?.nominativo}</div>
                    <div class="s-meta"> 142 vendite · Risponde in 2h</div>
                  </div>
                  <div class="s-actions">

                  </div>
                </div>
                `
              }, ()=>true, {
                class: 'col-lg-12',
                onClick: (Oggetto: any, component: FieldViewerComponent)=>{
                  component.router.navigate(['marketplace/shared/dynamicedit/dettaglio_negozio', Oggetto.esclusiva])
                },
                azioni:[
                  // Visita negozio →
                  {
                    label: "Visita negozio →",
                    type: 'func',
                    func: (field, bottone, campo, Oggetto, api: ApiPathsService, component: FieldViewerComponent) => {
                      component.router.navigate(['marketplace/shared/dynamicedit/dettaglio_negozio', Oggetto.esclusiva])
                    },
                    class: 'btn-visita'
                  }

                ]
              }),
            ]
          }),

        ]
      }),
      CampoAggiuntivo.Html("", '<div class="rel-ttl" id="relTtl" onclick="openNegozio(\'Antonio Marras\')">\n' +
        '        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>\n' +
        '        Altri prodotti del negozio\n' +
        '      </div>', () => true, {
        class: 'col-lg-12 dl',
        onClick: (field, component: FieldViewerComponent) => {
          component.router.navigate(["marketplace/shared/dynamiclist/negozio", field.esclusiva])
        }
      }),
      CampoAggiuntivo.InputField("", "AltriNegozio", "", "dl col-lg-12 rel-row", {
        type: 'ArrayCampiAggiuntivi',
      }),

    ],
    MenuItems: [
      {
        path: "",
        title: "Compra",
        icon: "",
        class: "",
        extralink: true,
        submenu: []
      },
      {
        path: 'shared/dynamiclist/catalogo',
        title: "Catalogo",
        icon: "fas fa-cart",
        class: "",
        capacita: [],
      }
    ]
  }
  return OBJ;
}


export var CatalogoEnv = () => {
  var env: any = {
    Modules: {
      "Catalogo": true
    },
    Cruds: [Catalogo()],
    Menu: [...Catalogo().MenuItems]
  }
  return env;

}
